/**
 * Every blog-cms sentence admin renders, written once (RV3.9). Mockup card M1 is the source, kept
 * verbatim where the spec gives it.
 */
export const BLOG_CMS_COPY = {
  heading: "Blog CMS",
  signingIn: "Signing you in to the blog editor…",
  unauthorisedTitle: "Blog CMS is limited to super admins",
  rateLimitedTitle: "Too many sign-in attempts.",
  rateLimitedBody: "Sign-in to the editor allows 10 attempts a minute.",
  canRetry: "You can try again now.",
  failed: "Couldn't sign you in to the blog editor.",
  failedBody: "Check your connection, then try again.",
  reauthExhaustedTitle: "The blog editor keeps signing you out",
  reauthExhaustedBody: "Retry once, or sign in to admin again.",
  unreachableTitle: "Couldn't reach the blog editor",
  unreachableBody: "Nothing loaded in time.",
  reconnecting: "Reconnecting to the blog editor",
  reconnected: "Reconnected to the blog editor. If a save failed, save again.",
  reconnectFailed:
    "Couldn't reconnect to the blog editor. Don't close this tab: your unsaved text is still here.",
  popupBlocked: "Allow pop-ups for admin to open the editor in a new tab",
  retry: "Retry",
  signInAgain: "Sign in again",
  openInNewTab: "Open in new tab",
  editorActions: "Blog editor actions",
  frameTitle: "Blog editor",
  renewFrameTitle: "Blog editor session renewal",
  agentTitle: "Authorise AI agent",
  agentDescription:
    "Creates a one-time sign-in link for the AI agent. Open it in the agent's dedicated browser profile, never in this browser: it signs that profile in as the blog agent.",
  agentCreate: "Create agent sign-in link",
  agentCopy: "Copy link",
  agentClose: "Close",
  agentCopied: "Copied. Open it in the agent's dedicated browser profile within 45 s.",
  agentCopyFailed: "Couldn't copy — create a new link",
  agentExpired: "Link expired",
  agentFailed: "Couldn't create the agent link.",
  agentReady: "Link ready. Copy it once; it is not shown.",
} as const;

export function unauthorisedBody(role: string): string {
  return `You're signed in as ${role}.`;
}

/** The ticking line, kept out of the accessibility tree. */
export function rateLimitedVisible(secondsLeft: number): string {
  return `Try again in ${secondsLeft} s.`;
}

/**
 * The polite status. It changes only when `ceil(n / 10)` changes, and once at 0, so a 30 s count
 * speaks at most 3 times instead of 30 (U16).
 */
export function rateLimitedAnnouncement(secondsLeft: number): string {
  if (secondsLeft <= 0) return BLOG_CMS_COPY.canRetry;
  return `Try again in about ${Math.ceil(secondsLeft / 10) * 10} seconds.`;
}

export function rateLimitedToast(seconds: number): string {
  return `${BLOG_CMS_COPY.rateLimitedTitle} ${rateLimitedVisible(seconds)}`;
}
